import { useSetRecoilState, useResetRecoilState } from "recoil";
import { toastState } from "../recoil/Toast/atom";

export const useToast = () => {
  const setToast = useSetRecoilState(toastState);
  const resetToast = useResetRecoilState(toastState);

  return {
    success: ({ message, errorsCount, duration = 6000, showAnimation }) =>
      setToast({
        message,
        errorsCount,
        duration,
        type: "success",
        showAnimation
      }),
    error: ({ message, errorsCount, duration = 6000 }) =>
      setToast({ message, errorsCount, duration, type: "error" }),
    warning: ({ message, errorsCount, duration = 6000 }) =>
      setToast({ message, errorsCount, duration, type: "warning" }),
    clear: resetToast
  };
};
